export enum StorageEnum {
  PREFIX = 'inside_hub_app.',
  CURRENT_USER_ID = 'current-user-id',
  CURRENT_PARTNER_ID = 'current-partner-id',
}
